import { memo } from 'react';
import { pdfjs, Document } from 'react-pdf';

const pdfjsWorkerVersion = '2.0.2-rc3';
pdfjs.GlobalWorkerOptions.workerSrc = `/assets/cdn/pdfjs-worker@${pdfjsWorkerVersion}/pdf-worker.js`;
export const cMapUrl = `/assets/cdn/pdfjs-worker@${pdfjsWorkerVersion}/cmaps/`;

export default memo(Document);
